import { CONFIG_URL } from '@/utils/constants'

const CONFIG = () => `${CONFIG_URL}`

export default {
  CONFIG
}